<div class="container">
    <app-recent-messages 
        [title]="recentMesagesBlockTitle" 
        [iconUrl]="recentMessagesBlockIcon" 
        [messages]="messages.slice(0, recentMessagesDisplayCount)"
        [noMessagesText]="noMessagesText">
    </app-recent-messages>
    <app-all-messages
        [title]="allMessagesBlockTitle" 
        [iconUrl]="allMessagesBlockIcon" 
        [messages]="messages"
        [totalMessagesCount]="messagesCount"
        [pageSize]="allMessagesTablePageSize"
        [pinnedMessagesIds]="pinnedMessagesIds"
        [noMessagesText]="noMessagesText">
    </app-all-messages>
</div>
<button data-mfp-src="#main-popup" #eventSender class="d-none"></button>